import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../api/request';
import { AuthenticationError } from '../../../../api/requests/tuitionProcess';
import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../components/info/DisplayError';
import Loading from '../../../../components/info/Loading';
import { getFormData } from '../api';
import { FormDataResponseType } from '../types';

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  { periodId: number },
  FormDataResponseType,
  AuthenticationError | AxiosResultDefaultError
>();

export function usePerformanceAnalysisFiltersLoaderQuery() {
  const { query, updateQuery } = useFetch();
  return { query, updateQuery };
}

export function usePerformanceAnalysisFiltersLoader() {
  const result = useFetch();
  if (result.error) {
    throw new Error(
      'Ha ocurrido un error. Deberías usar este hook solo si puedes asegurar que no hay error',
    );
  }

  if (!result.data) {
    throw new Error(
      'No hay data. Deberías usar este hook solo si puedes asegurar que hay data',
    );
  }

  return result.data;
}

export function PerformanceAnalysisFiltersConsumer({
  children,
}: {
  children: ReactElement;
}) {
  return (
    <FetchConsumer>
      {({ data, error, loading, refresh }) => {
        if (error) {
          return (
            <DisplayError
              insideCard
              textBody={error.code}
              retryAction={refresh}
              loadingAction={loading}
            />
          );
        }

        if (loading) {
          return <Loading insideCard />;
        }

        if (!data) {
          return (
            <DisplayError
              insideCard
              textBody="Data no cargada"
              retryAction={refresh}
              loadingAction={loading}
            />
          );
        }

        return children;
      }}
    </FetchConsumer>
  );
}

export function PerformanceAnalysisFiltersLoader({
  periodId,
  children,
}: {
  periodId: number;
  children: ReactElement | ReactElement[];
}) {
  const request = useCallback(async ({ periodId }) => {
    return getFormData(periodId);
  }, []);

  return (
    <FetchProvider
      request={request}
      defaultQuery={{ periodId }}
      fetchImmediately
      children={children}
    />
  );
}
